// src/services/promoCodeService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  PROMO_CODE_LIST,
  PROMO_CODE_ADD,
  PROMO_CODE_UPDATE,
  PROMO_CODE_DELETE,
  PROMO_USER_DROPDOWN,
} from "../../config/constants"; // Adjust endpoints as per your config

const promoCodeService = createApi({
  reducerPath: "promoCodeService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["PromoCode"],
  endpoints: (builder) => ({
    getPromoCodes: builder.query({
      query: (bodyData) => ({
        url: PROMO_CODE_LIST, // Endpoint to fetch meal list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["PromoCode"],
    }),
    addPromoCode: builder.mutation({
      query: (mealData) => ({
        url: PROMO_CODE_ADD, // Endpoint to add a meal
        method: "POST",
        data: mealData, // PromoCode data for the request body
      }),
      invalidatesTags: ["PromoCode"],
    }),
    updatePromoCode: builder.mutation({
      query: ({ promoCodeId, updatedData }) => ({
        url: `${PROMO_CODE_UPDATE}/${promoCodeId}`, // Endpoint to update a meal
        method: "PUT",
        data: updatedData, // Updated meal data
      }),
      invalidatesTags: ["PromoCode"],
    }),
    deletePromoCode: builder.mutation({
      query: (mealId) => ({
        url: `${PROMO_CODE_DELETE}/${mealId}`, // Endpoint to delete a meal
        method: "DELETE",
      }),
      invalidatesTags: ["PromoCode"],
    }),
    getUsersList: builder.query({
      query: () => ({
        url: `${PROMO_USER_DROPDOWN}`, // Endpoint to delete a meal
        method: "GET",
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetPromoCodesQuery,
  useAddPromoCodeMutation,
  useUpdatePromoCodeMutation,
  useDeletePromoCodeMutation,
  useGetUsersListQuery,
} = promoCodeService;

// Export the reducer to be included in the store
export default promoCodeService;
